import { config } from './domainConfig';

export const isMovioPlus = config.product === 'moviotv' && config.subdomain === 'plus';
